import { createSelector } from '@ngrx/store';
import { RootState } from '../../root-store/root.state';
import { SearchFormType } from '../search-page-type.enum';
import { includes } from 'lodash-es';

export const selectSeSearchFeature = (type: SearchFormType) => (state: RootState) => state.searchPage[type];

export const selectSeSearchItems = (type: SearchFormType) =>
    createSelector(selectSeSearchFeature(type), (state) => state.items);

export const selectSeSearchSelectedItemIds = (type: SearchFormType) =>
    createSelector(selectSeSearchFeature(type), (state) => state.selectedItems);

export const selectSeSearchDiff = (type: SearchFormType) =>
    createSelector(selectSeSearchFeature(type), (state) => state.diff);

export const selectSeSearchLeftSlider = (type: SearchFormType) =>
    createSelector(selectSeSearchFeature(type), (state) => state.leftSlider);

export const selectSeSearchRightSlider = (type: SearchFormType) =>
    createSelector(selectSeSearchFeature(type), (state) => state.rightSlider);

export const selectSeSearchTimeline = (type: SearchFormType) =>
    createSelector(selectSeSearchFeature(type), (state) => state.timeline);

export const selectSeSearchSelectedItems = (type: SearchFormType, idPropertyName: string) =>
    createSelector(selectSeSearchSelectedItemIds(type), selectSeSearchItems(type), (selectedItems, items) =>
        items.filter((item) => includes(selectedItems, item[idPropertyName])),
    );

export const selectSeSelectedEquipment = (type: SearchFormType) =>
    createSelector(selectSeSearchFeature(type), (state) => state.selectedEquipment);

// Seleziona stato salvato delle due sliders per la  pagina passata come parametro
export const selectSeSearchSliders = (type: SearchFormType) =>
    createSelector(selectSeSearchFeature(type), (state) => ({
        right: state.rightSlider,
        left: state.leftSlider,
        timeline: state.timeline,
    }));

export const selectSeSelectedBurnDevice = (type: SearchFormType) =>
    createSelector(selectSeSearchFeature(type), (state) => state.selectedBurnDevice);

export const selectSeToolbarRightSliderChecked = (type: SearchFormType) =>
    createSelector(selectSeSearchFeature(type), (state) => state.rightSlider.checked);

export const selectSeToolbarLeftSliderChecked = (type: SearchFormType) =>
    createSelector(selectSeSearchFeature(type), (state) => state.leftSlider.checked);

export const selectSeActualSearchType = (type: SearchFormType) =>
    createSelector(selectSeSearchFeature(type), (state) => state.actualSearchType);
